import React from "react";

interface ProgressIndicatorModalProps {
  current: number;
  total: number;
  message?: string;
}

const ProgressIndicatorModal: React.FC<ProgressIndicatorModalProps> = ({
  current,
  total,
  message = "登録中...",
}) => {
  const percentage = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 200,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* 中央のモーダル */}
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "24px 32px",
          minWidth: "320px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <p
          style={{
            color: "#374151",
            fontWeight: 500,
            fontSize: "16px",
            margin: "0 0 12px 0",
            textAlign: "center",
          }}
        >
          {message}
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "8px",
            fontSize: "14px",
            color: "#6b7280",
          }}
        >
          <span>
            {current} / {total} 件完了
          </span>
          <span>{percentage}%</span>
        </div>
        <div
          style={{
            width: "100%",
            backgroundColor: "#e5e7eb",
            borderRadius: "9999px",
            height: "8px",
          }}
        >
          <div
            style={{
              backgroundColor: "#2563eb",
              height: "8px",
              borderRadius: "9999px",
              transition: "width 0.3s ease",
              width: `${percentage}%`,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicatorModal;
